import { UserTypes } from '../types';

export const systemUser: Pick<UserTypes.User, 'userId' | 'email'> = {
  email: 'system@syte-vc.com',
  userId: 1,
};
